import { Component } from '@angular/core';

@Component({
  selector: 'loader-component',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss', '../../../../styles/page.preset.style.scss'],
  standalone: false,
})
export class LoaderComponent {}
